import { Controller } from 'stimulus';

export default class extends Controller {
  index: number;
  template: HTMLTableRowElement;

  templateTarget: HTMLTableSectionElement;
  tbodyTarget: HTMLTableSectionElement;

  static get targets() {
    return ['template', 'tbody'];
  }

  connect() {
    if (this.templateTarget) {
      this.template = this.templateTarget.children[0] as HTMLTableRowElement;
      this.templateTarget.remove();
    }
    this.index = this.tbodyTarget.children.length - 1;
  }

  add(evt) {
    evt.preventDefault();
    if (this.template) {
      this.tbodyTarget.appendChild(this.createOrderline());
    }
  }

  createOrderline() {
    this.index += 1;

    const row = this.template.cloneNode(true) as HTMLTableRowElement;
    row.querySelectorAll('input, select, textarea').forEach((field) => {
      ['id', 'name'].forEach((attr) => {
        if (field.hasAttribute(attr)) {
          field.setAttribute(
            attr,
            field
              .getAttribute(attr)
              .replace(/{{ index }}/, this.index.toString())
          );
        }
      });
    });
    return row;
  }
}
